import { canShowMicroIcon, getModelName, isDeviceClickable } from "../../utils";
import { Link } from "../../components";
import { ReactComponent as PlayIcon } from "../../assets/icons/device-media-control.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/device-setting-icon.svg";
import { ReactComponent as VoiceControlIcon } from "../../assets/icons/micro-icon.svg";
import cn from "classnames";
import { deviceImages } from "../../constants/images";
import { oemValues } from "../../constants/oem";
import { selectDevice } from "../../redux/voiceControl-slice";
import sharedStyles from "../../shared.module.scss";
import styles from "./DeviceCardGridView.module.scss";
import { useDispatch } from "react-redux";

export function DeviceCardGridView({ device }) {
  const dispatch = useDispatch();
  function handleDeviceCardClick() {
    if (!isDeviceClickable(device.model)) return;
    window.open(`https://${device.cloudId}.${oemValues.cloudDomain}`, "_blank");
  }

  return (
    <div
      className={styles.deviceCard}
      onClick={handleDeviceCardClick}
      style={{
        backgroundImage: `url(${deviceImages[device.model]}`,
        cursor: isDeviceClickable(device.model) ? "pointer" : "default",
      }}
    >
      <div className={styles.deviceCardWrapper}>
        <div className={cn(styles.deviceModel, sharedStyles.secondaryText)}>
          {getModelName(device.model)}
        </div>
        <div className={cn(styles.deviceName, sharedStyles.formText)}>
          {getModelName(device.model, device.friendly_name)}
        </div>
        <div className={styles.deviceBtnGroup}>
          <Link
            to={`/device-settings/${device.cloudId}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={styles.deviceIconLink}
          >
            <SettingsIcon className={styles.deviceSettingsIcon} />
          </Link>
          {canShowMicroIcon(device) && (
            <Link
              /* This route only exists on mobile, but will be automatically
               * redirected to /voice on desktop (see routes in App.js)
               */
              to={`/voice/${device.cloudId}/controls`}
              onClick={(e) => {
                dispatch(selectDevice(device));
                e.stopPropagation();
              }}
              className={styles.deviceIconLink}
            >
              <VoiceControlIcon className={styles.deviceMicroIcon} />
            </Link>
          )}
          {isDeviceClickable(device.model) && (
            <PlayIcon className={styles.devicePlayIcon} />
          )}
        </div>
      </div>
    </div>
  );
}
